export default "__VITE_ASSET__B$LVNAfb__"